import { css } from "@emotion/react";

export const appBar = css`
    background: #fff;
    color: #000;
    box-shadow: none;
    z-index: 1201; /* Ensure it stays above other content */
`;

export const toolbar = css`
    display: flex;
    justify-content: start;
    align-items: center;
    padding: 2px 2rem 0px;
`;

export const navLinks = css`
    display: none; /* Hide the links by default on smaller screens */
    justify-content: flex-start;

    align-items: center;
    
    @media (min-width: 692px) {
        display: flex; /* Show the links on larger screens */
        width:100%
    }
`;

export const drawer = css`
    width: 250px;
    flex-shrink: 0;

    & .MuiDrawer-paper {
        width: 250px;
        background-color: #333;
        color: white;
    }
`;

export const drawerContent = css`
    padding: 2rem;
    margin-top: 4rem;
`;

export const separator = css`
    width: 1px;
    padding:1px;
    height: 30px;
    margin: 0 20px;
    z-index:9999;
    background: #636468;
`;

export const profileHolder = css`
    display: flex;
    align-items: center;
    margin-left:auto;
    margin-right:10px;
    
    & h3 {
        font-weight: 500;
        font-family: 'Manrope', sans-serif;
        margin: 0;
        
        & span {
            margin: 0 15px 0 5px;
        }
    }
`;

export const homeIcon = css`
    color: #636468;
    font-size: 2.6rem;
    cursor: pointer;

    &:hover {
        color: #ff5100;
    }
`;

export const activeHomeIcon = css`
    cursor: default;
    color: #ff5100;
`;

export const contactIcon = css`
    color: #636468;
    font-size: 2.3rem;
    cursor: pointer;
    margin-right:2px;
    margin-top: 4px;

    &:hover {
        color: #ff5100;
    }
`;

export const inputIcon = css`
    color: #ff5100;
    margin-right: 5px;
    
    '& .MuiSvgIcon-root': {
        font-size: 10rem !important;
    }
`;

export const visibilityIcon = css`
    color: #ff5100;
    margin-left: 5px;
    cursor: pointer;
`;

export const avatarIcon = css`
    cursor: pointer;

    &:hover {
        background: #ff5100 !important;
    }

    & > div:nth-child(1) {
        font-size: 12px !important;
    }
`;

export const changePasswordIcon = css`
    color: #636468;
    font-size: 2.3rem;
    cursor: pointer;
    margin-right:10px;

    &:hover {
        color: #ff5100;
    }
`;

export const menuItem = css`
    color: #ffffff;
    font-family: Manrope;
`;

export const portfolioName = css`
    font-size: 1rem;
    margin-right: 20px;
    font-family: 'Manrope', sans-serif;
    
    & span {
        text-decoration: underline;
        text-underline-position: under;
        font-weight: bold;
    }
`;

export const backBtn = css`
    text-transform:none;
    padding: 5px 15px;
    margin:0px 20px 0px 40px;
    color:white;
    background-color:#ff5100;
    cursor:pointer;
    border-radius:5px;
    border:none;
    font-family: 'Manrope', sans-serif;

    &:focus-visible {
        outline: none !important; 
    }
`;

export const showBtn = css`
    text-transform:none;
    padding: 5px 15px;
    color:white;
    background-color:#ff5100;
    cursor:pointer;
    border-radius:5px;
    border:none;
    font-family: 'Manrope', sans-serif;

    &:focus-visible {
        outline: none !important; 
    }
`;

export const uploadBtn= css`
    text-transform: none;
    padding: 5px 15px;
    color: white;
    background-color: #3a963a;
    cursor: pointer;
    border-radius: 5px;
    border: none; /* Added missing semicolon */
    transition: background 0.3s ease;
    font-family: 'Manrope', sans-serif;

    &:focus, &:focus-visible {
        outline: none !important;
    }
`;

export const intradayHolder = css`
    padding: 6px 24px;
    margin: 0 auto;
`

export const navLink = css`
    cursor: pointer;
    font-weight: 500;
    font-family: 'Manrope', sans-serif;
    margin: 0;
    
    &:hover, &.active {
        color: #ff5100;
    }
`

export const selectWrapper = css`
    position: relative;
    display: inline-block;
    width: fit-content;
`

export const organizationSelect = css`
    width: 100%;
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    
    padding: 8px 36px 8px 12px;
    border-radius: 6px;
    border: 1px solid #d1d5db;
    background: white;
    color: #374151;
    font-size: 14px;
    cursor: pointer;
    font-family: 'Manrope', sans-serif;

    &:focus {
      outline: none;
      border-color: #ff5100;
    }
`

export const arrow = css`
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
    pointer-events: none;
    color: #ff5100;
    display: flex;
    align-items: center;
`